import { produce } from 'immer';

import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_DELETE,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

export interface EditingDocumentIdsInPagesState {
  [id: string]: string[];
}

const initialState: EditingDocumentIdsInPagesState = {};

export default function reducer(
  state: EditingDocumentIdsInPagesState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_CREATE:
      return produce(state, (draft) => {
        const { page, uuid } = action.payload.meta;
        if (state[page]) {
          draft[page].push(uuid);
        } else {
          draft[page] = [uuid];
        }
      });
    case EDITING_DOCUMENT__FIELD_DELETE:
      return produce(state, (draft) => {
        const { uuid, page } = action.payload;
        draft[page] = draft[page].filter((id) => id !== uuid);
      });
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
